<template>
	<div class="header bm bm-ac bm-pc">
		<div class="header_box bm bm-ac bm-pj">
			<div class="bm bm-ac">
				<img class="runzhong_logo" src="@/assets/runzhong_logo.png" alt="" @click="$router.push('/')">
				<img class="tianqing_logo" src="@/assets/tianqing_logo.png" alt="" @click="$router.push('/')">
			</div>
			<!-- 导航菜单（结合Vue Router） -->
			<nav class="nav-menu bm">
				<!-- 关于润众制药 - 二级菜单 -->
				<div class="simple-mega-menu-wrapper"
					@mouseenter="openAboutMenu"
					@mouseleave="closeAboutMenu"
				>
					<!-- 一级路由 -->
					<RouterLink 
						to="/about" 
						class="nav-item bm bm-ac bm-pc"
						:class="{ 'active': isAboutMenuOpen }"
						@click="handleAboutClick">
						关于润众制药
						<div class="border_bottom"></div>
					</RouterLink>
					<div v-if="isAboutMenuOpen" class="white-background-panel-is-about"></div>
					<!-- 全屏白色背景板 -->
					<Transition v-if="isAboutMenuOpen" name="menu-fade">
						<div class="simple-mega-menu-panel about-panel" @click.stop>
							<div class="simple-mega-menu-content">
								<RouterLink 
									to="/about/company" 
									class="mega-menu-item" 
									@click="closeAboutMenu"
									:class="{ 'active': $route.path === '/about/company' }">
									企业概况
								</RouterLink>
								<RouterLink 
									to="/about/history" 
									class="mega-menu-item"
									@click="closeAboutMenu"
									:class="{ 'active': $route.path.startsWith('/about/history') }">
									发展历程
								</RouterLink>
							</div>
						</div>
					</Transition>
				</div>
				
				<RouterLink to="/news" class="nav-item bm bm-ac bm-pc">新闻与媒体<div class="border_bottom"></div></RouterLink>
				
				<!-- 产品服务 - 二级菜单 -->
				<div class="simple-mega-menu-wrapper"
					@mouseenter="openProductsMenu"
					@mouseleave="closeProductsMenu"
				>
					<!-- 一级路由 -->
					<RouterLink 
						to="/products" 
						class="nav-item bm bm-ac bm-pc"
						:class="{ 'active': isProductsMenuOpen }"
						@click="handleProductsClick">
						产品服务
						<div class="border_bottom"></div>
					</RouterLink>
					<div v-if="isProductsMenuOpen" class="white-background-panel"></div>
					<!-- 全屏白色背景板 -->
					<Transition v-if="isProductsMenuOpen" name="menu-fade">
						<div class="simple-mega-menu-panel products-panel" @click.stop>
							<div class="simple-mega-menu-content">
								<RouterLink 
									to="/products/active" 
									class="mega-menu-item" 
									@click="closeProductsMenu"
									:class="{ 'active': $route.path === '/products/active' }">
									化学原料药
								</RouterLink>
								<RouterLink 
									to="/products/inter" 
									class="mega-menu-item"
									@click="closeProductsMenu"
									:class="{ 'active': $route.path.startsWith('/products/inter') }">
									化药中间体
								</RouterLink>
								<RouterLink 
									to="/products/bioDrug" 
									class="mega-menu-item"
									@click="closeProductsMenu"
									:class="{ 'active': $route.path === '/products/bioDrug' || $route.path.match(/^\/products\/bioDrug(\/|$)/) }">
									生物药
								</RouterLink>
								<RouterLink 
									to="/products/bioDrugIntermediate" 
									class="mega-menu-item"
									@click="closeProductsMenu"
									:class="{ 'active': $route.path.startsWith('/products/bioDrugIntermediate') }">
									生物药中间体
								</RouterLink>
								<RouterLink 
									to="/products/bioEnzyme" 
									class="mega-menu-item"
									@click="closeProductsMenu"
									:class="{ 'active': $route.path.startsWith('/products/bioEnzyme') }">
									生物催化酶
								</RouterLink>
								<RouterLink 
									to="/products/ref" 
									class="mega-menu-item"
									@click="closeProductsMenu"
									:class="{ 'active': $route.path.startsWith('/products/ref') }">
									对照品
								</RouterLink>
								<RouterLink 
									to="/products/cmo" 
									class="mega-menu-item"
									@click="closeProductsMenu"
									:class="{ 'active': $route.path.startsWith('/products/cmo') }">
									CMO/CDMO业务
								</RouterLink>
							</div>
						</div>
					</Transition>
				</div>
				<div class="nav-item bm bm-ac bm-pc" @click="toExternalPage">招贤纳士<div class="border_bottom"></div></div>
				<RouterLink to="/contact" class="nav-item bm bm-ac bm-pc">联系我们<div class="border_bottom"></div></RouterLink>
			</nav>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

// 关于润众制药菜单状态
const isAboutMenuOpen = ref(false)
const aboutCloseTimer = ref<number | null>(null)

// 产品服务菜单状态
const isProductsMenuOpen = ref(false)
const productsCloseTimer = ref<number | null>(null)

// 打开关于润众制药菜单
const openAboutMenu = () => {
	if (aboutCloseTimer.value) {
		clearTimeout(aboutCloseTimer.value)
		aboutCloseTimer.value = null
	}
	isAboutMenuOpen.value = true
}

// 关闭关于润众制药菜单
const closeAboutMenu = () => {
	if (aboutCloseTimer.value) {
		clearTimeout(aboutCloseTimer.value)
	}
	aboutCloseTimer.value = window.setTimeout(() => {
		isAboutMenuOpen.value = false
		aboutCloseTimer.value = null
	}, 150)
}

// 处理关于润众制药点击事件
const handleAboutClick = (e: Event) => {
	if (isAboutMenuOpen.value) {
		e.preventDefault()
		closeAboutMenu()
	}
}

// 打开产品服务菜单
const openProductsMenu = () => {
	if (productsCloseTimer.value) {
		clearTimeout(productsCloseTimer.value)
		productsCloseTimer.value = null
	}
	isProductsMenuOpen.value = true
}

// 关闭产品服务菜单
const closeProductsMenu = () => {
	if (productsCloseTimer.value) {
		clearTimeout(productsCloseTimer.value)
	}
	productsCloseTimer.value = window.setTimeout(() => {
		isProductsMenuOpen.value = false
		productsCloseTimer.value = null
	}, 150)
}

// 处理产品服务点击事件
const handleProductsClick = (e: Event) => {
	if (isProductsMenuOpen.value) {
		e.preventDefault()
		closeProductsMenu()
	}
}

// 路由变化时关闭所有菜单
watch(() => route.path, () => {
	closeAboutMenu()
	closeProductsMenu()
})

// 原有的跳转外部页面函数
const toExternalPage = () => {
	console.log(configData.value?.recruit_url[0], "跳转链接")
	window.open(configData.value?.recruit_url[0])
}

// 获取配置信息
import { useConfigStore } from "@/stores/index.ts";
import { computed } from 'vue';
const store = useConfigStore()
const configData = computed(() => {
	console.log(store.configData,"store.configData")
	return store.configData
})
</script>

<style lang="styl" scoped>
/* 导航栏基础布局 */
.header {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 70px;
	margin: 0 auto;
	background-color: #fff;
	text-align: center;
	z-index: 1000;
	min-width: 1200px;
	.header_box {
		width: 80%;
		height: 100%;
		.runzhong_logo {
			width: 124px;
			height: 36px;
			margin-right: 23px;
			cursor: pointer;
		}
		.tianqing_logo {
			height: 30px;
			cursor: pointer;
		}
		
		.nav-menu {
			height: 100%;
			
			.nav-item {
				color: #323232;
				font-size: 16px;
				height: 100%;
				padding: 12px;
				cursor: pointer;
				position: relative;
				text-decoration: none;
				transition: all 0.2s ease;
				.border_bottom{
					width: 0;
					height: 3px;
					background-color: #00549b;
					position: absolute;
					bottom: 15px;
					left: 50%;
					transform: translateX(-50%);
					transition: width 0.3s ease;
				}
			}
			
			.nav-item:hover,
			.nav-item.router-link-active {
				position: relative;
				.border_bottom {
					width: 80%;
				}
			}
		}
	}
}

/* 简单巨型菜单包装器 */
.simple-mega-menu-wrapper {
	position: relative;
	height: 100%;
	display: flex;
	align-items: center;
	
	.nav-item {
		display: flex;
		align-items: center;
	}
}

/* 全屏白色背景板 */
.white-background-panel {
	width: 100vw;
	height: 290px;
	background-color: #fff;
	box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
	border-top: 1px solid #f0f0f0;
	display: flex;
	justify-content: center;
	position: fixed;
	top: 70px;
	left: 0;
	width: 100vw;
	z-index: 999;
}
.white-background-panel-is-about {
	width: 100vw;
	height: 105px;
	background-color: #fff;
	box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
	border-top: 1px solid #f0f0f0;
	display: flex;
	justify-content: center;
	position: fixed;
	top: 70px;
	left: 0;
	width: 100vw;
	z-index: 999;
}

/* 全屏下拉面板 */
.simple-mega-menu-panel {
	width: 140px;
	z-index: 1999;
	position: absolute;
	top: 70px;
	left: -30%;
	align-items: center;
}

/* 为不同菜单调整位置 */
.about-panel {
	left: -10%; /* 调整关于菜单的位置 */
}

.products-panel {
	left: -30%; /* 保持原有产品菜单位置 */
}

/* 单列内容容器 */
.simple-mega-menu-content {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	margin: 15px 0
}

/* 二级菜单项 - 简洁样式 */
.mega-menu-item {
	display: block;
	padding: 8px 0;
	color: #333;
	font-size: 16px;
	text-decoration: none;
	text-align: left;
	position: relative;
	transition: all 0.2s ease;
	width: 100%;
	text-align: center;
	&:hover {
		color: #1989fa !important;
	}
	
	&.active {
		color: #1989fa !important;
		font-weight: 500;
	}
}

/* 菜单淡入淡出动画 */
.menu-fade-enter-active,
.menu-fade-leave-active {
	transition: opacity 0.3s ease;
}

.menu-fade-enter-from,
.menu-fade-leave-to {
	opacity: 0;
}

@media (max-width: 1200px) {
	.header {
		min-width: 100%;
		
		.header_box {
			width: 95%;
		}
	}
}
</style>